import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { RouterProvider } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/auth/AuthContext";
import { queryClient } from "@/lib/react-query/config";
import { router } from "@/router/config";
export default function AppProvider() {
    return /*#__PURE__*/ _jsxs(QueryClientProvider, {
        client: queryClient,
        children: [
            /*#__PURE__*/ _jsxs(AuthProvider, {
                children: [
                    /*#__PURE__*/ _jsx(RouterProvider, {
                        future: {
                            v7_startTransition: true
                        },
                        router: router
                    }),
                    /*#__PURE__*/ _jsx(Toaster, {
                        position: "top-right",
                        closeButton: true,
                        toastOptions: {
                            duration: 5000,
                            classNames: {
                                error: '!text-red-900 !border-0 !border-l-4 !border-l-red-500',
                                success: '!text-green-900 !border-0 !border-l-4 !border-l-green-500',
                                warning: '!text-yellow-900 !border-0 !border-l-4 !border-l-yellow-500',
                                info: '!text-blue-900 !border-0 !border-l-4 !border-l-blue-500',
                                closeButton: '!border !border-gray-300'
                            }
                        }
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(ReactQueryDevtools, {
                initialIsOpen: false
            })
        ]
    });
}
